"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalculateHighrollerPackage = void 0;
var public_api_1 = require("@l2p/public-api");
var react_1 = require("react");
var bonuses_1 = require("../bonuses");
var currencies_1 = require("../currencies");
var tags_1 = require("./tags");
var usePromotionsByTag_1 = require("./usePromotionsByTag");
var useCalculateHighrollerPackage = function () {
    var currency = (0, currencies_1.useCurrentCurrency)();
    var affBonusData = (0, bonuses_1.useAffiliateBonuses)().data;
    var firstDepositBonus = (0, usePromotionsByTag_1.usePromotionsByTag)(tags_1.BonusTag.WELCOME_DEPOSIT_FIRST_HIGHROLLER).promotions;
    var secondDepositBonus = (0, usePromotionsByTag_1.usePromotionsByTag)(tags_1.BonusTag.WELCOME_DEPOSIT_SECOND_HIGHROLLER).promotions;
    var thirdDepositBonus = (0, usePromotionsByTag_1.usePromotionsByTag)(tags_1.BonusTag.WELCOME_DEPOSIT_THIRD_HIGHROLLER).promotions;
    var fourthDepositBonus = (0, usePromotionsByTag_1.usePromotionsByTag)(tags_1.BonusTag.WELCOME_DEPOSIT_FOURTH_HIGHROLLER).promotions;
    var data = (0, bonuses_1.useBonusesByType)(public_api_1.BonusType.Deposit).data;
    var highrollerBonuses = (0, react_1.useMemo)(function () {
        if (!firstDepositBonus ||
            !secondDepositBonus ||
            !thirdDepositBonus ||
            !fourthDepositBonus)
            return [];
        return __spreadArray(__spreadArray(__spreadArray([
            affBonusData && (affBonusData === null || affBonusData === void 0 ? void 0 : affBonusData.length) > 0
                ? affBonusData === null || affBonusData === void 0 ? void 0 : affBonusData[0]
                : firstDepositBonus === null || firstDepositBonus === void 0 ? void 0 : firstDepositBonus[0]
        ], secondDepositBonus, true), thirdDepositBonus, true), fourthDepositBonus, true);
    }, [
        affBonusData,
        firstDepositBonus,
        fourthDepositBonus,
        secondDepositBonus,
        thirdDepositBonus,
    ]);
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var freeSpins = 0;
        var amount = 0;
        var percent = 0;
        var currentBonus = {
            percent: '300%',
            fs: 150,
            amount: 300,
            addedToBalanceAmount: 0,
        };
        if (data === null || data === void 0 ? void 0 : data.length) {
            var percentFromFirstBonus = ((_b = (_a = data[0].rewards) === null || _a === void 0 ? void 0 : _a.find(function (r) { return r.type === 'RELATIVE'; })) === null || _b === void 0 ? void 0 : _b.relativePercent) ||
                0;
            // percent = percentFromFirstBonus;
            currentBonus.percent =
                percentFromFirstBonus > 0 ? "".concat(percentFromFirstBonus, "%") : 0;
            var fsFromFirstBonus = ((_d = (_c = data[0].rewards) === null || _c === void 0 ? void 0 : _c.find(function (r) {
                return r.type === 'FREE_ROUNDS' || r.type === 'REPEATABLE_FREE_ROUNDS';
            })) === null || _d === void 0 ? void 0 : _d.freeRoundsCount) || 0;
            var addedToBalanceAmountFromFirstBonus = ((_h = (_g = (_f = (_e = data[0].rewards) === null || _e === void 0 ? void 0 : _e.find(function (r) { return r.type === 'ABSOLUTE'; })) === null || _f === void 0 ? void 0 : _f.addedToBalance) === null || _g === void 0 ? void 0 : _g.find(function (b) { return b.currency === currency; })) === null || _h === void 0 ? void 0 : _h.amount) || 0;
            currentBonus.fs = fsFromFirstBonus;
            currentBonus.addedToBalanceAmount = addedToBalanceAmountFromFirstBonus;
            var amountFromFirstBonus = (_k = (_j = data[0].constraints) === null || _j === void 0 ? void 0 : _j.find(function (r) { return r.type === 'MAX_BONUS'; })) === null || _k === void 0 ? void 0 : _k.maxBonus;
            currentBonus.amount = (_l = amountFromFirstBonus === null || amountFromFirstBonus === void 0 ? void 0 : amountFromFirstBonus.find(function (b) { return b.currency === currency; })) === null || _l === void 0 ? void 0 : _l.amount;
        }
        highrollerBonuses === null || highrollerBonuses === void 0 ? void 0 : highrollerBonuses.forEach(function (bonus, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var freeRoundsCountData = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _a === void 0 ? void 0 : _a.find(function (r) { return !!(r === null || r === void 0 ? void 0 : r.freeRoundsCount); });
            var percentsCountData = (_b = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _b === void 0 ? void 0 : _b.find(function (r) { return !!(r === null || r === void 0 ? void 0 : r.relativePercent); });
            var freeRoundsCount = freeRoundsCountData === null || freeRoundsCountData === void 0 ? void 0 : freeRoundsCountData.freeRoundsCount;
            var percentsCount = percentsCountData === null || percentsCountData === void 0 ? void 0 : percentsCountData.relativePercent;
            freeSpins += freeRoundsCount || 0;
            percent += percentsCount || 0;
            var maxBonusData = (_c = bonus === null || bonus === void 0 ? void 0 : bonus.constraints) === null || _c === void 0 ? void 0 : _c.find(function (r) { return (r === null || r === void 0 ? void 0 : r.type) === 'MAX_BONUS'; });
            var maxBonus = (_d = maxBonusData === null || maxBonusData === void 0 ? void 0 : maxBonusData.maxBonus) === null || _d === void 0 ? void 0 : _d.find(function (b) { return b.currency === currency; });
            var maxBonusAmount = maxBonus === null || maxBonus === void 0 ? void 0 : maxBonus.amount;
            if (idx === 0) {
                var percentFromFirstBonus = ((_f = (_e = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _e === void 0 ? void 0 : _e.find(function (r) { return r.type === 'RELATIVE'; })) === null || _f === void 0 ? void 0 : _f.relativePercent) ||
                    0;
                // percent = percentFromFirstBonus;
                var fsFromFirstBonus = ((_h = (_g = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _g === void 0 ? void 0 : _g.find(function (r) {
                    return r.type === 'FREE_ROUNDS' || r.type === 'REPEATABLE_FREE_ROUNDS';
                })) === null || _h === void 0 ? void 0 : _h.freeRoundsCount) || 0;
                if (!(data === null || data === void 0 ? void 0 : data.length)) {
                    currentBonus.percent =
                        percentFromFirstBonus > 0 ? "".concat(percentFromFirstBonus, "%") : 0;
                    currentBonus.fs = fsFromFirstBonus;
                }
                if (data === null || data === void 0 ? void 0 : data.length) {
                    var amountFromFirstBonus = (_k = (_j = data[0].constraints) === null || _j === void 0 ? void 0 : _j.find(function (r) { return r.type === 'MAX_BONUS'; })) === null || _k === void 0 ? void 0 : _k.maxBonus;
                    currentBonus.amount = (_l = amountFromFirstBonus === null || amountFromFirstBonus === void 0 ? void 0 : amountFromFirstBonus.find(function (b) { return b.currency === currency; })) === null || _l === void 0 ? void 0 : _l.amount;
                }
            }
            amount += maxBonusAmount || 0;
        });
        return {
            first: highrollerBonuses[0],
            percent: Number(percent) > 0 ? "".concat(percent, "%") : 0,
            freeSpins: freeSpins,
            amount: amount,
            currency: currency,
            currentBonus: currentBonus,
            affBonus: !!affBonusData,
        };
    }, [affBonusData, data, currency, highrollerBonuses]);
};
exports.useCalculateHighrollerPackage = useCalculateHighrollerPackage;
